<script>
import SettingsMenuItem from '@/components/SettingsMenuItem'
import AccountPreview from '@/components/AccountPreview'
import EnvironmentUtils from '@/utils/environmentUtils'
import config from '~/config/index'

export default
{
    name: 'settings-index',

    props:
    {
    },

    created ()
    {
    },

    render () 
    {
        const user = this.$store.state.user

        return (
            <div id='settings-index-view'>
                {
                    user.isLogged ?
                    ([
                        <account-preview user={user} />,
                        <SettingsMenuItem on-click={this.onItemClicked} name='Se déconnecter' path='logout' icon={require('@/assets/img/logout.svg')} separator={false} />,
                        <SettingsMenuItem on-click={this.onItemClicked} name='Mon Compte' path='accounts/me' icon={require('@/assets/img/user.svg')} />
                    ]) :
                    (
                        <SettingsMenuItem on-click={this.onItemClicked} name='Se connecter' path='login' icon={require('@/assets/img/key.svg')} separator={false} />
                    )
                }

                <SettingsMenuItem on-click={this.onItemClicked} name='Apparence' icon={require('@/assets/img/paint-brush.svg')} path='theme' />
                <SettingsMenuItem on-click={this.onItemClicked} name='Notifications' icon={require('@/assets/img/bell.svg')} path='notifications' />
                <SettingsMenuItem on-click={this.onItemClicked} name="Conditions générales d'utilisation" icon={require('@/assets/img/lock.svg')} path='eula' />
                <SettingsMenuItem on-click={this.onItemClicked} name="Politique de confidentialité" icon={require('@/assets/img/lock.svg')} path='privacy-policy' />
                <SettingsMenuItem on-click={this.onItemClicked} name='À propos de cette application' icon={require('@/assets/img/question-mark.svg')} path='about' />

                {
                    !EnvironmentUtils.isProductionEnv &&
                    (
                        <SettingsMenuItem on-click={this.onItemClicked} name='Devtools' icon={require('@/assets/img/curly-brackets.svg')} path='devtools' />
                    )
                }
            </div>
        )
    },

    mounted ()
    {
    },

    data () 
    {
        return {
        }
    },

    computed:
    {
    },

    watch:
    {
    },

    methods:
    {
        onItemClicked ({ event, component } = {})
        {
            switch (component.path)
            {
                case 'eula':
                    window.open(config.eulaUrl, '_system')
                    break
                case 'privacy-policy':
                    window.open(config.privacyPolicyUrl, '_system')
                    break

                default:
                    this.$router.push({ path: component.path, append: true })
            }
        }
    },

    components:
    {
        SettingsMenuItem,
        AccountPreview
    }
}
</script>

<style lang='less'>
#settings-index-view
{
    
}
</style>


// WEBPACK FOOTER //
// src/views/SettingsIndex.vue